import React, { useState } from "react";
import axios from "axios";
import Breadcrumb from "../components/breadcrumb/Breadcrumb";
import { contact } from "../assets/data/data";
import { toast } from "react-toastify";
import UseFetch from "../components/hooks/UseFetch";
const Contact = () => {
  const [message, setMessage] = useState({
    fullName: "",
    email: "",
    phone: "",
    message: "",
  });
  const changeHandler = (e) => {
    setMessage({ ...message, [e.target.name]: e.target.value });
  };
  const SendContact = async () => {
    console.log(message);

    try {
      // setLoading(true);

      const res = await axios.post(
        process.env.REACT_APP_SERVER_URL + "contacts",
        message
      );
      if (res.status === 201) {
        toast.success("Xabar yuborildi !", {
          theme: "colored",
          position: "top-right",
        });
        // setLoading(false);
        setMessage({ fullName: "", email: "", phone: "", message: "" });
      }
    } catch (error) {
      if (error.status === 412) {
        toast.warn("Ma'lumotlar to'liq kiritilmagan !", {
          theme: "colored",
          position: "top-right",
        });
      } else {
        toast.error("Server xatoligi!", {
          theme: "colored",
          position: "top-right",
        });
        console.log(error);
      }
    }
  };
  return (
    <>
      <Breadcrumb current="Contact" />
      <section className="contact">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="contact-items">
                <h2 className="mb-4 fw-bold">Biz bilan bog'laning</h2>
                <div className="contact-item d-flex mb-2 ">
                  <div className="item-icon me-4 fs-4 theme-bg p-2 rounded-circle">
                    <i className="fas fa-map-marked-alt"></i>
                  </div>
                  <div className="item-text">
                    <h5>Manzil</h5>
                    <a href={contact?.map.location} target="blank">
                      {contact.map.name}
                    </a>
                  </div>
                </div>
                <div className="contact-item d-flex mb-2 ">
                  <div className="item-icon me-4 fs-4 theme-bg p-2 rounded-circle">
                    <i className="fas fa-phone"></i>
                  </div>
                  <div className="item-text">
                    <h5>Telefon</h5>
                    <a href={`tel:${contact.tel}`}>{contact.tel}</a>
                  </div>
                </div>
                <div className="contact-item d-flex mb-2 ">
                  <div className="item-icon me-4 fs-4 theme-bg p-2 rounded-circle">
                    <i className="fas fa-envelope"></i>
                  </div>
                  <div className="item-text">
                    <h5>Email</h5>
                    <a href={"mailto:" + contact.email}>{contact.email}</a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="contact-form box">
                <h2 className="text-center fs-4 fw-bold mb-5">
                  Xabar qoldiring
                </h2>
                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="form-group mb-3">
                    <input
                      type="text"
                      name="fullName"
                      placeholder="Ism"
                      className="form-control"
                      value={message.fullName}
                      onChange={changeHandler}
                    />
                  </div>
                  <div className="form-group mb-3">
                    <input
                      type="email"
                      name="email"
                      placeholder="Email manzil"
                      className="form-control"
                      value={message.email}
                      onChange={changeHandler}
                    />
                  </div>
                  <div className="form-group mb-3">
                    <input
                      type="number"
                      name="phone"
                      placeholder="Telefon raqam"
                      className="form-control"
                      value={message.phone}
                      onChange={changeHandler}
                    />
                  </div>
                  <div className="form-group mb-3">
                    <textarea
                      placeholder="Xabar"
                      name="message"
                      className="form-control"
                      value={message.message}
                      onChange={changeHandler}
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    className="theme-btn w-100"
                    onClick={() => SendContact()}
                  >
                    Yuborish
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
